
import { NoseurObject } from "@rivtn/noseur";
import { BaseService, SanitizedResponse } from "../BaseService";

export enum FeeType {

    MEMBER_WITHDRAWAL = "MEMBER_WITHDRAWAL",
    TOURNAMENT_REGISTRATION = "TOURNAMENT_REGISTRATION",
    TOURNAMENT_CURRENCY_ALLOCATION = "TOURNAMENT_CURRENCY_ALLOCATION",
    TOURNAMENT_REGISTRATION_REFUND = "TOURNAMENT_REGISTRATION_REFUND",

}

export interface IChargeFee {
    type: FeeType;
    external_id: string;
    amounts: NoseurObject<number>;
    amount_type: "AMOUNT" | "PERCENTAGE";
    amounts_min_caps: NoseurObject<number>;
    amounts_max_caps: NoseurObject<number>;
}

export class ChargesFeeService extends BaseService {

    protected static instance: ChargesFeeService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!ChargesFeeService.instance) ChargesFeeService.instance = new ChargesFeeService();
        return ChargesFeeService.instance;
    }

    get(params: NoseurObject<string | number | any[]> = { page: 1, size: 10 }): Promise<SanitizedResponse<IChargeFee>> {
        return this.report(this.transport.get(`/v1/platform/fee/get`, { query: this.normalizeParams(params) }));
    }

    getFlatAmount(chargeFee: IChargeFee, amount: number, currency: string) {
        if (!(currency in chargeFee.amounts)) {
            return 0;
        }
        let chargeAmount = chargeFee.amounts[currency];
        if (chargeFee.amount_type === "PERCENTAGE") {
            chargeAmount = ((amount * chargeAmount) / 100);
        }
        if ((currency in chargeFee.amounts_min_caps)) {
            chargeAmount = Math.max(chargeAmount, chargeFee.amounts_min_caps[currency]);
        }
        if ((currency in chargeFee.amounts_max_caps)) {
            chargeAmount = Math.min(chargeAmount, chargeFee.amounts_max_caps[currency]);
        }
        return chargeAmount;
    }

    getMinimumCapAmount(chargeFee: IChargeFee, currency: string) {
        let minAmount = 0;
        if (currency && chargeFee.amounts_min_caps && (currency in chargeFee.amounts_min_caps)) {
            minAmount = chargeFee.amounts_min_caps[currency];
        }
        return minAmount;
    }

    getMaximumCapAmount(chargeFee: IChargeFee, currency: string) {
        let minAmount = 0;
        if (currency && chargeFee.amounts_max_caps && (currency in chargeFee.amounts_max_caps)) {
            minAmount = chargeFee.amounts_max_caps[currency];
        }
        return minAmount;
    }

    getPercentageCharged(totalAmount: number, originalAmount: number) {
        return (((totalAmount - originalAmount) / totalAmount) * 100);
    }

}
